import type { BranchSearch, BranchSearchDto } from '../types';

export function branchSearchFromDto(dto: BranchSearchDto): BranchSearch{
  return {
    id: dto.id,
    short: dto.bran_short,
    name: dto.bran_name,
  };
}
